import React from 'react'
import PropTypes from 'prop-types'
import './style.css'


const Tab = (props) => {

    const activeClass = props.active ? 'active' : ''

    return (
        <button style={props.styles} className={'tab ' + activeClass }
                onClick={props.onClick}>

            {props.children }
        </button>
    )
}

Tab.propTypes = {
    children: PropTypes.any.isRequired ,
    onClick: PropTypes.func.isRequired ,
    active: PropTypes.bool,
    styles: PropTypes.object,
}

Tab.defaultProps = {}

export default Tab



// WEBPACK FOOTER //
// ./src/components/_common/TabContainer/Tab/index.js